import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { _ as o } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index44.css';const b = "_page-container_1btbn_1", _ = "_background_1btbn_5", g = "_content_1btbn_14", n = {
  pageContainer: b,
  background: _,
  content: g
};
function N(a) {
  const {
    className: c,
    contentClassName: s,
    children: r,
    contentAs: i = "div",
    containerAs: l = "div",
    background: t
  } = a, m = i;
  return /* @__PURE__ */ d(l, { className: o(n.pageContainer, c), children: [
    t && /* @__PURE__ */ e("div", { className: n.background, children: t }),
    /* @__PURE__ */ e(m, { className: o(n.content, s), children: r })
  ] });
}
export {
  N as default
};
